import React, { useState, useRef, useEffect } from "react";
import ReactDOM from "react-dom";
import { kpiDefinitions } from "./kpiDefinitions";

const iconInfo = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="32"
    fill="#ffffff"
    viewBox="0 0 256 256"
  >
    <path d="M142,176a6,6,0,0,1-6,6,14,14,0,0,1-14-14V128a2,2,0,0,0-2-2,6,6,0,0,1,0-12,14,14,0,0,1,14,14v40a2,2,0,0,0,2,2A6,6,0,0,1,142,176ZM124,94a10,10,0,1,0-10-10A10,10,0,0,0,124,94Zm106,34A102,102,0,1,1,128,26,102.12,102.12,0,0,1,230,128Zm-12,0a90,90,0,1,0-90,90A90.1,90.1,0,0,0,218,128Z"></path>
  </svg>
);

// --- LOGICA INTERNA CONDIVISA ---
// Questo componente gestisce solo la visualizzazione: Label + Arrow + Icona + Tooltip
const InfoIconContent = ({ label, suffix }) => {
  const [showTooltip, setShowTooltip] = useState(false);
  const [tooltipPos, setTooltipPos] = useState({
    top: 0,
    left: 0,
    translateX: "-50%",
    arrowLeft: "50%",
  });
  const iconRef = useRef(null);
  const tooltipRef = useRef(null);

  const definition = kpiDefinitions[label];

  useEffect(() => {
    function handleClickOutside(event) {
      if (
        iconRef.current &&
        !iconRef.current.contains(event.target) &&
        tooltipRef.current &&
        !tooltipRef.current.contains(event.target)
      ) {
        setShowTooltip(false);
      }
    }

    function handleScroll() {
      if (showTooltip) setShowTooltip(false);
    }

    document.addEventListener("mousedown", handleClickOutside);
    window.addEventListener("scroll", handleScroll, true);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      window.removeEventListener("scroll", handleScroll, true);
    };
  }, [showTooltip]);

  const handleIconClick = (e) => {
    e.stopPropagation();
    if (!showTooltip) {
      const rect = iconRef.current.getBoundingClientRect();
      const screenWidth = window.innerWidth;
      const iconCenter = rect.left + rect.width / 2;

      // Default: centrato
      let newTranslateX = "-50%";
      let newArrowLeft = "50%";

      // SOGLIA: Se l'icona è negli ultimi 280px a DESTRA dello schermo
      if (iconCenter > screenWidth - 280) {
        newTranslateX = "-90%";
        newArrowLeft = "90%";
      }
      // SOGLIA: Se l'icona è nei primi 280px a SINISTRA dello schermo
      else if (iconCenter < 280) {
        newTranslateX = "-10%";
        newArrowLeft = "10%";
      }

      setTooltipPos({
        top: rect.bottom + 5,
        left: iconCenter,
        translateX: newTranslateX,
        arrowLeft: newArrowLeft,
      });
    }
    setShowTooltip(!showTooltip);
  };

  const tooltipContent = definition && (
    <div
      className="definition-tooltip"
      ref={tooltipRef}
      style={{
        top: tooltipPos.top,
        left: tooltipPos.left,
        transform: `translateX(${tooltipPos.translateX})`,
        "--arrow-left": tooltipPos.arrowLeft,
      }}
      onClick={(e) => e.stopPropagation()}
    >
      <strong>{definition.title}</strong>
      {definition.description && (
        <p style={{ marginTop: "8px", marginBottom: "8px" }}>
          {definition.description}
        </p>
      )}
      {definition.type === "formula" && (
        <div
          className="formula-container"
          style={{ marginTop: definition.description ? "0" : "4px" }}
        >
          {definition.numerator && definition.denominator ? (
            <div className="formula-row">
              {" "}
              <div className="formula-fraction">
                <span className="numerator">{definition.numerator}</span>
                <span className="denominator">{definition.denominator}</span>
              </div>
              {/* SE ESISTE IL SUFFISSO LO MOSTRIAMO A DESTRA */}
              {definition.suffix && (
                <span className="formula-suffix">{definition.suffix}</span>
              )}{" "}
            </div>
          ) : (
            <div
              style={{
                fontFamily: '"Courier New", Courier, monospace',
                marginTop: "4px",
              }}
            >
              {definition.text}
            </div>
          )}
          {definition.note && (
            <span className="formula-note">{definition.note}</span>
          )}
        </div>
      )}
    </div>
  );

  return (
    <div
      className="th-content"
      style={{ display: "inline-flex", alignItems: "center" }}
    >
      <span>
        {label}
        {suffix}{" "}
      </span>

      {definition && (
        <>
          <div
            ref={iconRef}
            className={`info-icon-wrapper ${showTooltip ? "active" : ""}`}
            onClick={handleIconClick}
            style={{ marginLeft: "6px" }}
          >
            {iconInfo}
          </div>
          {showTooltip && ReactDOM.createPortal(tooltipContent, document.body)}
        </>
      )}
    </div>
  );
};

// --- COMPONENTE 1: Per i Constraints (Default Export) ---
const InfoIcon = ({ label }) => {
  return <InfoIconContent label={label} />;
};

export default InfoIcon;

// --- COMPONENTE 2: Per le Tabelle (Named Export) ---
export const SortableHeader = ({ label, sortKey, onSort, sortIndicator }) => {
  return (
    <th
      onClick={() => sortKey && onSort(sortKey)}
      style={{ cursor: sortKey ? "pointer" : "default" }}
    >
      <InfoIconContent label={label} suffix={sortIndicator} />
    </th>
  );
};
